import e, { useState as n, useEffect as o } from "react";
function t(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var o = 0, t = Array(n); o < n; o++) t[o] = e[o];
  return t;
}
function r(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != o) {
      var t,
        r,
        a,
        l,
        i = [],
        c = !0,
        s = !1;
      try {
        if (a = (o = o.call(e)).next, 0 === n) {
          if (Object(o) !== o) return;
          c = !1;
        } else for (; !(c = (t = a.call(o)).done) && (i.push(t.value), i.length !== n); c = !0);
      } catch (e) {
        s = !0, r = e;
      } finally {
        try {
          if (!c && null != o.return && (l = o.return(), Object(l) !== l)) return;
        } finally {
          if (s) throw r;
        }
      }
      return i;
    }
  }(e, n) || i(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function a(e) {
  return function (e) {
    if (Array.isArray(e)) return t(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || i(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function l(e) {
  return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, l(e);
}
function i(e, n) {
  if (e) {
    if ("string" == typeof e) return t(e, n);
    var o = {}.toString.call(e).slice(8, -1);
    return "Object" === o && e.constructor && (o = e.constructor.name), "Map" === o || "Set" === o ? Array.from(e) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? t(e, n) : void 0;
  }
}
var c = {
  "consent-modal-container": "ConsentModal-module_consent-modal-container__nDtVX",
  "on-config": "ConsentModal-module_on-config__Wan4Q",
  "config-icon": "ConsentModal-module_config-icon__w5hPi",
  "modal-hidden": "ConsentModal-module_modal-hidden__RRjr2",
  "base-layout": "ConsentModal-module_base-layout__8IXVi",
  "page-hidden": "ConsentModal-module_page-hidden__voW9W",
  "config-layout": "ConsentModal-module_config-layout__K-r3Y",
  "scroll-wrap": "ConsentModal-module_scroll-wrap__OoTRf",
  section: "ConsentModal-module_section__-QPuu",
  "active-toggle": "ConsentModal-module_active-toggle__NKQu4",
  "section-default": "ConsentModal-module_section-default__KzpE5",
  icon: "ConsentModal-module_icon__ceJU-"
};
function s(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
!function (e, n) {
  void 0 === n && (n = {});
  var o = n.insertAt;
  if (e && "undefined" != typeof document) {
    var t = document.head || document.getElementsByTagName("head")[0],
      r = document.createElement("style");
    r.type = "text/css", "top" === o && t.firstChild ? t.insertBefore(r, t.firstChild) : t.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}('.ConsentModal-module_consent-modal-container__nDtVX {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  margin: 20px;\n  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);\n  background-color: #fff;\n  max-width: 315px;\n  border-radius: 5px;\n  padding: 25px;\n  font-family: "roboto", sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX.ConsentModal-module_on-config__Wan4Q {\n  border-radius: 100%;\n  padding: 8px;\n  cursor: pointer;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-icon__w5hPi {\n  display: inline-block;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-icon__w5hPi svg {\n  width: 36px;\n  height: 36px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX.ConsentModal-module_modal-hidden__RRjr2 {\n  display: none;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi {\n  opacity: 98%;\n  transition: all 300ms ease 100ms;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi.ConsentModal-module_page-hidden__voW9W {\n  display: none;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi h6 {\n  margin: 0;\n  font-family: "protipo-narrow";\n  text-transform: capitalize;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: normal;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi p {\n  margin: 15px 0;\n  font-size: 14px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi ul li a {\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  padding: 8px 0;\n  display: block;\n  font-weight: 700;\n  text-decoration: underline;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi ul li a:hover {\n  color: unset;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_base-layout__8IXVi ul li:last-child a {\n  border-radius: 3px;\n  padding: 8px 15px;\n  background-color: #005eb8;\n  color: #fff !important;\n  text-decoration: none;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y {\n  transition: all 0.5s ease;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y.ConsentModal-module_page-hidden__voW9W {\n  display: none;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_scroll-wrap__OoTRf {\n  height: 200px;\n  overflow-y: scroll;\n  overscroll-behavior-y: contain;\n  overflow-x: hidden;\n  /* Works on Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #002b49 transparent;\n  /* Works on Chrome, Edge, and Safari */\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_scroll-wrap__OoTRf::-webkit-scrollbar {\n  width: 6px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_scroll-wrap__OoTRf::-webkit-scrollbar-track {\n  background: transparent;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_scroll-wrap__OoTRf::-webkit-scrollbar-thumb {\n  background-color: #002b49;\n  border-radius: 25px;\n  border: 5px solid transparent;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y ul {\n  margin: 0;\n  padding: 0 0 20px 0;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y ul li a {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu {\n  position: relative;\n  padding-left: 36px;\n  padding-right: 25px;\n  margin-bottom: 30px;\n  opacity: 98%;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu a {\n  font-family: "protipo-narrow";\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 700;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu p {\n  font-size: 13px;\n  margin: 8px 0 15px 0;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu > a:hover {\n  color: unset;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu > a:hover::after {\n  transform: translateX(12px);\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu > a::after {\n  content: " ";\n  display: inline-block;\n  width: 8px;\n  height: 10px;\n  vertical-align: middle;\n  margin-left: 6px;\n  background: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none"><path d="M1.49991 0.90918L5.59082 5.00009L1.49991 9.091" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\') left center no-repeat;\n  background-size: contain;\n  transition: all 300ms ease-in-out;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span {\n  display: flex;\n  justify-content: space-between;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span strong {\n  font-size: 14px;\n  font-weight: 700;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span a i {\n  width: 34px;\n  height: 22px;\n  background-color: #5B6770;\n  display: inline-block;\n  border-radius: 17px;\n  position: relative;\n  padding: 3px;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span a i::after {\n  content: " ";\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  border-radius: 50%;\n  background-color: #fff;\n  display: block;\n  transition: all 300ms ease-in-out;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span a i.ConsentModal-module_active-toggle__NKQu4 {\n  background-color: #005eb8;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu span a i.ConsentModal-module_active-toggle__NKQu4::after {\n  transform: translateX(12px);\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu.ConsentModal-module_section-default__KzpE5 span a {\n  pointer-events: none;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu.ConsentModal-module_section-default__KzpE5 span a::before {\n  font-family: "roboto", sans-serif;\n  content: "Required";\n  color: #868E96;\n  font-size: 12px;\n  margin-right: 10px;\n  vertical-align: 6px;\n  font-weight: 400;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu.ConsentModal-module_section-default__KzpE5 span a i.ConsentModal-module_active-toggle__NKQu4 {\n  background-color: #002b49;\n}\n.ConsentModal-module_consent-modal-container__nDtVX .ConsentModal-module_config-layout__K-r3Y .ConsentModal-module_section__-QPuu .ConsentModal-module_icon__ceJU- {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}');
var u,
  d = {
    exports: {}
  },
  f = {
    exports: {}
  },
  p = {};
var m,
  y,
  _,
  g,
  w,
  v,
  b,
  h,
  C,
  M,
  x,
  E,
  S,
  k,
  O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function j() {
  return y || (y = 1, "production" === process.env.NODE_ENV ? f.exports = function () {
    if (u) return p;
    u = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      o = e ? Symbol.for("react.portal") : 60106,
      t = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      l = e ? Symbol.for("react.provider") : 60109,
      i = e ? Symbol.for("react.context") : 60110,
      c = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      d = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      m = e ? Symbol.for("react.suspense_list") : 60120,
      y = e ? Symbol.for("react.memo") : 60115,
      _ = e ? Symbol.for("react.lazy") : 60116,
      g = e ? Symbol.for("react.block") : 60121,
      w = e ? Symbol.for("react.fundamental") : 60117,
      v = e ? Symbol.for("react.responder") : 60118,
      b = e ? Symbol.for("react.scope") : 60119;
    function h(e) {
      if ("object" == typeof e && null !== e) {
        var u = e.$$typeof;
        switch (u) {
          case n:
            switch (e = e.type) {
              case c:
              case s:
              case t:
              case a:
              case r:
              case f:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case i:
                  case d:
                  case _:
                  case y:
                  case l:
                    return e;
                  default:
                    return u;
                }
            }
          case o:
            return u;
        }
      }
    }
    function C(e) {
      return h(e) === s;
    }
    return p.AsyncMode = c, p.ConcurrentMode = s, p.ContextConsumer = i, p.ContextProvider = l, p.Element = n, p.ForwardRef = d, p.Fragment = t, p.Lazy = _, p.Memo = y, p.Portal = o, p.Profiler = a, p.StrictMode = r, p.Suspense = f, p.isAsyncMode = function (e) {
      return C(e) || h(e) === c;
    }, p.isConcurrentMode = C, p.isContextConsumer = function (e) {
      return h(e) === i;
    }, p.isContextProvider = function (e) {
      return h(e) === l;
    }, p.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, p.isForwardRef = function (e) {
      return h(e) === d;
    }, p.isFragment = function (e) {
      return h(e) === t;
    }, p.isLazy = function (e) {
      return h(e) === _;
    }, p.isMemo = function (e) {
      return h(e) === y;
    }, p.isPortal = function (e) {
      return h(e) === o;
    }, p.isProfiler = function (e) {
      return h(e) === a;
    }, p.isStrictMode = function (e) {
      return h(e) === r;
    }, p.isSuspense = function (e) {
      return h(e) === f;
    }, p.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === t || e === s || e === a || e === r || e === f || e === m || "object" == typeof e && null !== e && (e.$$typeof === _ || e.$$typeof === y || e.$$typeof === l || e.$$typeof === i || e.$$typeof === d || e.$$typeof === w || e.$$typeof === v || e.$$typeof === b || e.$$typeof === g);
    }, p.typeOf = h, p;
  }() : f.exports = (m || (m = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      o = e ? Symbol.for("react.portal") : 60106,
      t = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      a = e ? Symbol.for("react.profiler") : 60114,
      l = e ? Symbol.for("react.provider") : 60109,
      i = e ? Symbol.for("react.context") : 60110,
      c = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      u = e ? Symbol.for("react.forward_ref") : 60112,
      d = e ? Symbol.for("react.suspense") : 60113,
      f = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      m = e ? Symbol.for("react.lazy") : 60116,
      y = e ? Symbol.for("react.block") : 60121,
      _ = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      w = e ? Symbol.for("react.scope") : 60119;
    function v(e) {
      if ("object" == typeof e && null !== e) {
        var f = e.$$typeof;
        switch (f) {
          case n:
            var y = e.type;
            switch (y) {
              case c:
              case s:
              case t:
              case a:
              case r:
              case d:
                return y;
              default:
                var _ = y && y.$$typeof;
                switch (_) {
                  case i:
                  case u:
                  case m:
                  case p:
                  case l:
                    return _;
                  default:
                    return f;
                }
            }
          case o:
            return f;
        }
      }
    }
    var b = c,
      h = s,
      C = i,
      M = l,
      x = n,
      E = u,
      S = t,
      k = m,
      j = p,
      V = o,
      I = a,
      P = r,
      N = d,
      D = !1;
    function T(e) {
      return v(e) === s;
    }
    O.AsyncMode = b, O.ConcurrentMode = h, O.ContextConsumer = C, O.ContextProvider = M, O.Element = x, O.ForwardRef = E, O.Fragment = S, O.Lazy = k, O.Memo = j, O.Portal = V, O.Profiler = I, O.StrictMode = P, O.Suspense = N, O.isAsyncMode = function (e) {
      return D || (D = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(e) || v(e) === c;
    }, O.isConcurrentMode = T, O.isContextConsumer = function (e) {
      return v(e) === i;
    }, O.isContextProvider = function (e) {
      return v(e) === l;
    }, O.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, O.isForwardRef = function (e) {
      return v(e) === u;
    }, O.isFragment = function (e) {
      return v(e) === t;
    }, O.isLazy = function (e) {
      return v(e) === m;
    }, O.isMemo = function (e) {
      return v(e) === p;
    }, O.isPortal = function (e) {
      return v(e) === o;
    }, O.isProfiler = function (e) {
      return v(e) === a;
    }, O.isStrictMode = function (e) {
      return v(e) === r;
    }, O.isSuspense = function (e) {
      return v(e) === d;
    }, O.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === t || e === s || e === a || e === r || e === d || e === f || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === p || e.$$typeof === l || e.$$typeof === i || e.$$typeof === u || e.$$typeof === _ || e.$$typeof === g || e.$$typeof === w || e.$$typeof === y);
    }, O.typeOf = v;
  }()), O)), f.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function V() {
  if (g) return _;
  g = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    o = Object.prototype.propertyIsEnumerable;
  return _ = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, o = 0; o < 10; o++) n["_" + String.fromCharCode(o)] = o;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var t = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        t[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, t)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (t, r) {
    for (var a, l, i = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(t), c = 1; c < arguments.length; c++) {
      for (var s in a = Object(arguments[c])) n.call(a, s) && (i[s] = a[s]);
      if (e) {
        l = e(a);
        for (var u = 0; u < l.length; u++) o.call(a, l[u]) && (i[l[u]] = a[l[u]]);
      }
    }
    return i;
  }, _;
}
function I() {
  if (v) return w;
  v = 1;
  return w = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function P() {
  return h ? b : (h = 1, b = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var N = j();
  d.exports = function () {
    if (E) return x;
    E = 1;
    var e = j(),
      n = V(),
      o = I(),
      t = P(),
      r = function () {
        if (M) return C;
        M = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = I(),
            o = {},
            t = P();
          e = function e(_e) {
            var n = "Warning: " + _e;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function r(r, a, l, i, c) {
          if ("production" !== process.env.NODE_ENV) for (var s in r) if (t(r, s)) {
            var u;
            try {
              if ("function" != typeof r[s]) {
                var d = Error((i || "React class") + ": " + l + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw d.name = "Invariant Violation", d;
              }
              u = r[s](a, s, i, l, null, n);
            } catch (e) {
              u = e;
            }
            if (!u || u instanceof Error || e((i || "React class") + ": type specification of " + l + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in o)) {
              o[u.message] = !0;
              var f = c ? c() : "";
              e("Failed " + l + " type: " + u.message + (null != f ? f : ""));
            }
          }
        }
        return r.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (o = {});
        }, C = r;
      }(),
      a = function a() {};
    function l() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), x = function x(i, c) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        u = "<<anonymous>>",
        d = {
          array: y("array"),
          bigint: y("bigint"),
          bool: y("boolean"),
          func: y("function"),
          number: y("number"),
          object: y("object"),
          string: y("string"),
          symbol: y("symbol"),
          any: m(l),
          arrayOf: function arrayOf(e) {
            return m(function (n, t, r, a, l) {
              if ("function" != typeof e) return new p("Property `" + l + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
              var i = n[t];
              if (!Array.isArray(i)) return new p("Invalid " + a + " `" + l + "` of type `" + w(i) + "` supplied to `" + r + "`, expected an array.");
              for (var c = 0; c < i.length; c++) {
                var s = e(i, c, r, a, l + "[" + c + "]", o);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: m(function (e, n, o, t, r) {
            var a = e[n];
            return i(a) ? null : new p("Invalid " + t + " `" + r + "` of type `" + w(a) + "` supplied to `" + o + "`, expected a single ReactElement.");
          }),
          elementType: m(function (n, o, t, r, a) {
            var l = n[o];
            return e.isValidElementType(l) ? null : new p("Invalid " + r + " `" + a + "` of type `" + w(l) + "` supplied to `" + t + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return m(function (n, o, t, r, a) {
              if (!(n[o] instanceof e)) {
                var l = e.name || u;
                return new p("Invalid " + r + " `" + a + "` of type `" + ((i = n[o]).constructor && i.constructor.name ? i.constructor.name : u) + "` supplied to `" + t + "`, expected instance of `" + l + "`.");
              }
              var i;
              return null;
            });
          },
          node: m(function (e, n, o, t, r) {
            return g(e[n]) ? null : new p("Invalid " + t + " `" + r + "` supplied to `" + o + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return m(function (n, r, a, l, i) {
              if ("function" != typeof e) return new p("Property `" + i + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
              var c = n[r],
                s = w(c);
              if ("object" !== s) return new p("Invalid " + l + " `" + i + "` of type `" + s + "` supplied to `" + a + "`, expected an object.");
              for (var u in c) if (t(c, u)) {
                var d = e(c, u, a, l, i + "." + u, o);
                if (d instanceof Error) return d;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? m(function (n, o, t, r, a) {
              for (var l = n[o], i = 0; i < e.length; i++) if (f(l, e[i])) return null;
              var c = JSON.stringify(e, function (e, n) {
                return "symbol" === v(n) ? String(n) : n;
              });
              return new p("Invalid " + r + " `" + a + "` of value `" + String(l) + "` supplied to `" + t + "`, expected one of " + c + ".");
            }) : ("production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), l);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), l;
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              if ("function" != typeof r) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + b(r) + " at index " + n + "."), l;
            }
            return m(function (n, r, a, l, i) {
              for (var c = [], s = 0; s < e.length; s++) {
                var u = (0, e[s])(n, r, a, l, i, o);
                if (null == u) return null;
                u.data && t(u.data, "expectedType") && c.push(u.data.expectedType);
              }
              return new p("Invalid " + l + " `" + i + "` supplied to `" + a + "`" + (c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return m(function (n, t, r, a, l) {
              var i = n[t],
                c = w(i);
              if ("object" !== c) return new p("Invalid " + a + " `" + l + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
              for (var s in e) {
                var u = e[s];
                if ("function" != typeof u) return _(r, a, l, s, v(u));
                var d = u(i, s, r, a, l + "." + s, o);
                if (d) return d;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return m(function (r, a, l, i, c) {
              var s = r[a],
                u = w(s);
              if ("object" !== u) return new p("Invalid " + i + " `" + c + "` of type `" + u + "` supplied to `" + l + "`, expected `object`.");
              var d = n({}, r[a], e);
              for (var f in d) {
                var m = e[f];
                if (t(e, f) && "function" != typeof m) return _(l, i, c, f, v(m));
                if (!m) return new p("Invalid " + i + " `" + c + "` key `" + f + "` supplied to `" + l + "`.\nBad object: " + JSON.stringify(r[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var y = m(s, f, l, i, c + "." + f, o);
                if (y) return y;
              }
              return null;
            });
          }
        };
      function f(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function p(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function m(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          t = 0;
        function r(r, l, i, s, d, f, m) {
          if (s = s || u, f = f || i, m !== o) {
            if (c) {
              var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw y.name = "Invariant Violation", y;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var _ = s + ":" + i;
              !n[_] && t < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[_] = !0, t++);
            }
          }
          return null == l[i] ? r ? null === l[i] ? new p("The " + d + " `" + f + "` is marked as required in `" + s + "`, but its value is `null`.") : new p("The " + d + " `" + f + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(l, i, s, d, f);
        }
        var l = r.bind(null, !1);
        return l.isRequired = r.bind(null, !0), l;
      }
      function y(e) {
        return m(function (n, o, t, r, a, l) {
          var i = n[o];
          return w(i) !== e ? new p("Invalid " + r + " `" + a + "` of type `" + v(i) + "` supplied to `" + t + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function _(e, n, o, t, r) {
        return new p((e || "React class") + ": " + n + " type `" + o + "." + t + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.");
      }
      function g(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(g);
            if (null === e || i(e)) return !0;
            var n = function (e) {
              var n = e && (s && e[s] || e["@@iterator"]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var o,
              t = n.call(e);
            if (n !== e.entries) {
              for (; !(o = t.next()).done;) if (!g(o.value)) return !1;
            } else for (; !(o = t.next()).done;) {
              var r = o.value;
              if (r && !g(r[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function w(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function v(e) {
        if (null == e) return "" + e;
        var n = w(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function b(e) {
        var n = v(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return p.prototype = Error.prototype, d.checkPropTypes = r, d.resetWarningCache = r.resetWarningCache, d.PropTypes = d, d;
    }, x;
  }()(N.isElement, !0);
} else d.exports = function () {
  if (k) return S;
  k = 1;
  var e = I();
  function n() {}
  function o() {}
  return o.resetWarningCache = n, S = function S() {
    function t(n, o, t, r, a, l) {
      if (l !== e) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }
    function r() {
      return t;
    }
    t.isRequired = t;
    var a = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: r,
      element: t,
      elementType: t,
      instanceOf: r,
      node: t,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: o,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  };
}()();
var D = s(d.exports),
  T = function T(t) {
    var i = t.hide,
      s = t.backgroundColor,
      u = t.textColor,
      d = t.primaryColor,
      f = t.accentColor,
      p = t.callbackConsentValue,
      m = t.zIndex,
      y = t.cbModalStatus,
      _ = r(n(0), 2),
      g = _[0],
      w = _[1],
      v = r(n([0]), 2),
      b = v[0],
      h = v[1],
      C = r(n(i), 2),
      M = C[0],
      x = C[1],
      E = i && "modal-hidden",
      S = 0 === g ? c["base-layout"] : c["base-layout"] + " " + c["page-hidden"],
      k = 1 === g ? c["config-layout"] : c["config-layout"] + " " + c["page-hidden"];
    function O() {
      var e;
      void 0 !== window.rogers && (void 0 !== window.googletag ? window.googletag.cmd.push(function () {
        window.googletag.pubads().setPrivacySettings({
          nonPersonalizedAds: !window.rogers.consent.targeting
        });
      }) : null === (e = window) || void 0 === e || null === (e = e.adUtility) || void 0 === e || e.setAamUuid());
    }
    function j() {
      var e;
      O(), "object" === l(window._satellite) && "function" == typeof window._satellite.track && window._satellite.track("consentChoice"), void 0 !== window.utilityX && null !== (e = window.rogers) && void 0 !== e && null !== (e = e.consent) && void 0 !== e && e.functional && window.utilityX.reportAB(window.utilityX._var.enabled);
    }
    function V(e) {
      var n = window.localStorage.getItem("rsm_consent_config"),
        o = JSON.parse(n);
      return 1 === e ? null !== o && o.functional : 2 === e ? null !== o && o.performance : 3 === e && null !== o && o.targeting;
    }
    function I(e, n) {
      e.target.classList.toggle(c["active-toggle"]);
      var o = b.indexOf(n);
      o > -1 ? (b.splice(o, 1), h(b)) : h([].concat(a(b), [n]));
    }
    return o(function () {
      x(i);
    }, [i]), o(function () {
      if (void 0 !== window) {
        var e = window.localStorage.getItem("rsm_consent_config");
        window.rogers = e ? {
          consent: JSON.parse(e)
        } : {
          consent: {
            pending: !0,
            required: !1,
            functional: !1,
            performance: !1,
            targeting: !1
          }
        }, window.localStorage.setItem("consent-functional", !1), window.localStorage.setItem("consent-performance", !1), window.localStorage.setItem("consent-targeting", !1);
      }
    }, []), o(function () {
      var e = window.localStorage.getItem("rsm_consent_config"),
        n = null !== e && JSON.parse(e);
      window.vfConsent = window.vfConsent || {}, window.vfConsent.flag = -1, null != n && n.functional && !b.includes(1) && (h([].concat(a(b), [1])), window.localStorage.setItem("consent-functional", !0), window.vfConsent.flag = 1), null != n && n.performance && !b.includes(2) && (h([].concat(a(b), [2])), window.localStorage.setItem("consent-performance", !0), window.vfConsent.flag = 2), null != n && n.targeting && !b.includes(3) && (h([].concat(a(b), [3])), window.localStorage.setItem("consent-targeting", !0)), O();
    }), M ? e.createElement(e.Fragment, null) : e.createElement("div", {
      className: c["consent-modal-container"] + " " + c[E],
      style: {
        background: s,
        zIndex: m
      }
    }, e.createElement("div", {
      className: S,
      style: {
        color: u
      }
    }, e.createElement("h6", {
      style: {
        color: d
      }
    }, "Adjust preferences"), e.createElement("p", {
      style: {
        color: u
      }
    }, "With your consent we may collect cookies and information to enhance our service, and improve your experience."), e.createElement("ul", null, e.createElement("li", null, e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick() {
        return w(1);
      }
    }, "Configure")), e.createElement("li", null, e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick() {
        void 0 !== window && (window.rogers = {
          consent: {
            pending: !1,
            required: !0,
            functional: !0,
            performance: !0,
            targeting: !0
          }
        }, window.localStorage.setItem("consent", 1), window.localStorage.setItem("consent-functional", !0), window.localStorage.setItem("consent-performance", !0), window.localStorage.setItem("consent-targeting", !0), window.vfConsent.flag = 2, j(), p(function () {
          return window.rogers.consent;
        }), window.localStorage.setItem("rsm_consent_config", JSON.stringify(window.rogers.consent)), x(!0), y(function () {
          return !0;
        }), w(0));
      }
    }, "Allow All")))), e.createElement("div", {
      className: k,
      style: {
        color: u
      }
    }, e.createElement("ul", null, e.createElement("li", null, e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick() {
        return w(0);
      }
    }, e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512"
    }, e.createElement("path", {
      fill: d,
      d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    })))), e.createElement("li", null, e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick() {
        return e = b, void (void 0 !== window && void 0 !== window.rogers && e && (!0 === window.rogers.consent.pending && (window.rogers.consent.pending = !1), window.rogers.consent.required = !0, e.includes(1) && (window.rogers.consent.functional = !0, window.localStorage.setItem("consent-functional", !0), window.vfConsent.flag = 1), e.includes(1) || (window.rogers.consent.functional = !1, window.localStorage.setItem("consent-functional", !1), window.vfConsent.flag = -1), e.includes(2) && (window.rogers.consent.performance = !0, window.localStorage.setItem("consent-performance", !0), window.vfConsent.flag = 2), e.includes(2) || (window.rogers.consent.performance = !1, window.localStorage.setItem("consent-performance", !1), window.vfConsent.flag = -1), e.includes(3) && (window.rogers.consent.targeting = !0, window.localStorage.setItem("consent-targeting", !0)), e.includes(3) || (window.rogers.consent.targeting = !1, window.localStorage.setItem("consent-targeting", !1)), window.localStorage.setItem("consent", 1), window.localStorage.setItem("rsm_consent_config", JSON.stringify(window.rogers.consent)), x(!0), y(function () {
          return !0;
        }), w(0), j(), p(function () {
          return window.rogers.consent;
        })));
        var e;
      }
    }, e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512"
    }, e.createElement("path", {
      fill: d,
      d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    }))))), e.createElement("div", {
      className: c["scroll-wrap"]
    }, e.createElement("div", {
      className: c.section + " " + c["section-default"]
    }, e.createElement("i", {
      className: c.icon
    }, e.createElement("svg", {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M5.85711 16L6.92854 10.6429L2.64282 9.03571L10.1428 1L9.07139 6.35714L13.3571 7.96429L5.85711 16Z",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), e.createElement("span", null, e.createElement("strong", {
      style: {
        color: d
      }
    }, "Necessary"), e.createElement("a", {
      href: "#",
      style: {
        color: d
      }
    }, e.createElement("i", {
      className: c["active-toggle"]
    }))), e.createElement("p", {
      style: {
        color: u
      }
    }, "These cookies and data are essential for browsing our website and allowing services. Examples include, session, authentication, and security cookies."), e.createElement("a", {
      href: "https://www.rogerssportsandmedia.com/privacy-policy/#section17",
      style: {
        color: f
      }
    }, "More Details")), e.createElement("div", {
      className: c.section
    }, e.createElement("i", {
      className: c.icon
    }, e.createElement("svg", {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M14.0024 4.73374C14.1759 4.98218 14.3278 5.24504 14.4565 5.51941L16.3233 6.55737C16.5564 7.60143 16.5589 8.68378 16.3305 9.72889L14.4565 10.7668C14.3278 11.0412 14.1759 11.3041 14.0024 11.5525L14.0384 13.6933C13.2472 14.4143 12.3108 14.9574 11.2921 15.2863L9.4541 14.1834C9.15175 14.2051 8.84825 14.2051 8.5459 14.1834L6.71506 15.279C5.69319 14.9562 4.75369 14.4151 3.96161 13.6933L3.99765 11.5597C3.82557 11.3078 3.67373 11.0427 3.54354 10.7668L1.67667 9.72889C1.44357 8.68483 1.44111 7.60247 1.66947 6.55737L3.54354 5.51941C3.6722 5.24504 3.82412 4.98218 3.99765 4.73374L3.96161 2.59297C4.7528 1.872 5.68921 1.32883 6.70786 1L8.5459 2.10282C8.84825 2.0812 9.15175 2.0812 9.4541 2.10282L11.2849 1.00721C12.3068 1.33005 13.2463 1.87112 14.0384 2.59297L14.0024 4.73374Z",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      d: "M9.00012 11.6033C10.9109 11.6033 12.46 10.0543 12.46 8.14343C12.46 6.23262 10.9109 4.68359 9.00012 4.68359C7.08931 4.68359 5.54028 6.23262 5.54028 8.14343C5.54028 10.0543 7.08931 11.6033 9.00012 11.6033Z",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), e.createElement("span", null, e.createElement("strong", {
      style: {
        color: d
      }
    }, "Functional"), e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick(e) {
        return I(e, 1);
      }
    }, e.createElement("i", {
      className: V(1) ? c["active-toggle"] : ""
    }))), e.createElement("p", {
      style: {
        color: u
      }
    }, "These cookies and data enable the website to provide enhanced functionality and personalized content."), e.createElement("a", {
      href: "https://www.rogerssportsandmedia.com/privacy-policy/#section17",
      style: {
        color: f
      }
    }, "More Details")), e.createElement("div", {
      className: c.section
    }, e.createElement("i", {
      className: c.icon
    }, e.createElement("svg", {
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M16.5 1.66302V15.3359C16.5 15.512 16.43 15.6809 16.3055 15.8055C16.1809 15.93 16.012 16 15.8359 16H2.16302C2.03133 15.9998 1.90268 15.9604 1.79341 15.8869C1.68415 15.8134 1.5992 15.7091 1.54938 15.5872C1.49955 15.4653 1.48708 15.3313 1.51357 15.2023C1.54006 15.0733 1.6043 14.9551 1.69813 14.8627L15.3627 1.19813C15.4551 1.1043 15.5733 1.04006 15.7023 1.01357C15.8313 0.987085 15.9653 0.999547 16.0872 1.04938C16.2091 1.0992 16.3134 1.18415 16.3869 1.29341C16.4604 1.40268 16.4998 1.53133 16.5 1.66302Z",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      d: "M13.179 3.38135V15.9999",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      d: "M9.85913 6.70215V16",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      d: "M6.53809 10.0225V15.9997",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), e.createElement("span", null, e.createElement("strong", {
      style: {
        color: d
      }
    }, "Performance"), e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick(e) {
        return I(e, 2);
      }
    }, e.createElement("i", {
      className: V(2) ? c["active-toggle"] : ""
    }))), e.createElement("p", {
      style: {
        color: u
      }
    }, "These cookies and data inform us which pages are most informative and engaging via analytics."), e.createElement("a", {
      href: "https://www.rogerssportsandmedia.com/privacy-policy/#section17",
      style: {
        color: f
      }
    }, "More Details")), e.createElement("div", {
      className: c.section
    }, e.createElement("i", {
      className: c.icon
    }, e.createElement("svg", {
      width: "18",
      height: "16",
      viewBox: "0 0 18 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, e.createElement("path", {
      d: "M7.49997 4.43164V13.7091C7.50089 13.8089 7.47663 13.9072 7.42943 13.995C7.38223 14.0829 7.31363 14.1574 7.22997 14.2116L6.40497 14.7591C6.32505 14.8125 6.23348 14.8459 6.13797 14.8565C6.04245 14.8671 5.94579 14.8546 5.85612 14.82C5.76644 14.7855 5.68638 14.7299 5.62266 14.658C5.55894 14.586 5.51344 14.4998 5.48997 14.4066L4.49998 10.4316",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), e.createElement("path", {
      d: "M4.5 10.4302C3.70435 10.4302 2.94129 10.1142 2.37868 9.55157C1.81607 8.98896 1.5 8.2259 1.5 7.43025C1.5 6.6346 1.81607 5.87153 2.37868 5.30893C2.94129 4.74632 3.70435 4.43025 4.5 4.43025H7.5C7.5 4.43025 11.5875 4.43025 15.5175 1.13775C15.6049 1.06541 15.711 1.01934 15.8236 1.00489C15.9361 0.990435 16.0504 1.00818 16.1533 1.05608C16.2562 1.10397 16.3433 1.18005 16.4047 1.27548C16.4661 1.37091 16.4991 1.48179 16.5 1.59525V13.2652C16.4991 13.3787 16.4661 13.4896 16.4047 13.585C16.3433 13.6804 16.2562 13.7565 16.1533 13.8044C16.0504 13.8523 15.9361 13.8701 15.8236 13.8556C15.711 13.8411 15.6049 13.7951 15.5175 13.7227C11.5875 10.4302 7.5 10.4302 7.5 10.4302H4.5Z",
      stroke: f,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), e.createElement("span", null, e.createElement("strong", {
      style: {
        color: d
      }
    }, "Targeting"), e.createElement("a", {
      href: "javascript:void(0)",
      style: {
        color: d
      },
      onClick: function onClick(e) {
        return I(e, 3);
      }
    }, e.createElement("i", {
      className: V(3) ? c["active-toggle"] : ""
    }))), e.createElement("p", {
      style: {
        color: u
      }
    }, "These cookies may track data across websites for marketing and interest-based advertising to provide personalized content, offers, and advertisements."), e.createElement("a", {
      href: "https://www.rogerssportsandmedia.com/privacy-policy/#section17",
      style: {
        color: f
      }
    }, "More Details")))));
  };
T.propTypes = {
  backgroundColor: D.string,
  textColor: D.string,
  primaryColor: D.string,
  accentColor: D.string,
  hide: D.bool.isRequired,
  zIndex: D.number,
  callbackConsentValue: D.func,
  cbModalStatus: D.func
}, T.defaultProps = {
  backgroundColor: "#ffffff",
  textColor: "#5B6770",
  primaryColor: "#002B49",
  accentColor: "#005EB8",
  zIndex: "999",
  callbackConsentValue: function callbackConsentValue() {},
  cbModalStatus: function cbModalStatus() {}
};
export { T as ConsentModal, T as default };